import { css } from 'styled-components';

export function truncate(width) {
  return `
    width: ${width};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;
  `;
}

export const buttonReset = css`
  appearance: none;
  background: none;
  border-radius: 0;
  border: none;
  box-shadow: none;
  font-family: inherit;
  font-size: 100%;
  font-weight: inherit;
  line-height: 1.21;
  margin: 0;
  overflow: visible;
  padding: 0;
  text-align: inherit;
  text-transform: none;

  &:focus {
    outline-offset: -4px;
  }
`;
